module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/bus-c866b3b0537bca5af7b3b6969505b19c.svg&quot;;"